import { get } from "./src/entityId";
import uuid from "./src/uuid";

export default {
    get,
    uuid,
};
export { get, uuid };

